/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ./locale-data/complete.js (ignored)
// module id = 8
// module chunks = polyfills